module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/prevention-modal/prevention-modal.component.css
// module id = ./src/app/prevention-modal/prevention-modal.component.css
// module chunks = main